<template>
    <component
        :is="is"
        v-if="container.items.length > 1"
    >
        <li
            v-for="(item, index) in container.items"
            :key="index"
            :class="{'indicator-item_active': item === container.activeItem}"
            class="indicator-item"
        >
            <button
                class="indicator-button"
                @click="updateActiveItem(item)"
            />
        </li>
    </component>
</template>

<script>
import { container } from '@/js/util/carousel';
import dynamicComponent from '@/js/mixins/dynamic-component';

export default {
    name: 'CarouselIndicators',
    defaultTag: 'ul',
    mixins: [dynamicComponent],
    inject: { container },
    methods: {
        updateActiveItem(item) {
            this.container.$emit('updateActiveItem', item);
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/components/carousel/CarouselIndicators.vue